<template>
  <div class="block">
    <div class="block-title">支付宝小程序-优惠券</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="活动管理" name="eventManagement">
        <eventManagement ref="eventManagementRef" />
      </el-tab-pane>
      <el-tab-pane label="券使用情况" name="usage">
        <couponUsage ref="couponUsageRef" :activeName="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import eventManagement from "./eventManagement";
import couponUsage from "./couponUsage.vue";
export default {
  components: {
    eventManagement,
    couponUsage
  },
  data() {
    return {
      activeName: "eventManagement",
      agentName: "",
    };
  },
  mounted() {

  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(tab.name === 'eventManagement'){
        this.$refs.eventManagementRef.reset();
      }else if(tab.name === 'usage'){
        this.$refs.couponUsageRef.reset();
      }
      console.log(tab.name, event, "ee");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/couponGroupNew/index.vue